import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import CalendarCarAppointment from "./CalendarCarAppointment";
import CalendarCarAdvanceBooking from "./CalendarCarAdvanceBooking";
import CalendarNotificationInSystem from "./CalendarNotificationInSystem";
import CalendarNotificationSms from "./CalendarNotificationSms";

class Calendar extends React.Component {
  constructor(...props) {
    super(...props);

    this.state = { activeKey: 1 };
  }

  componentDidMount() {
    this.refs.calendar_car_appointment.loadData();
  }

  onTabsSelect(eventKey) {
    this.setState({ activeKey: eventKey });
    if (eventKey === 1) this.refs.calendar_car_appointment.loadData();
    else if (eventKey === 2)
      this.refs.calendar_notification_insystem.loadData();
    else if (eventKey === 3) this.refs.calendar_notification_sms.loadData();
    else if (eventKey === 4) this.refs.calendar_car_advancebooking.loadData();
  }

  render() {
    let { activeKey } = this.state;
    return (
      <div>
        <Tabs
          activeKey={activeKey}
          onSelect={this.onTabsSelect.bind(this)}
          id="uncontrolled-tab-example"
        >
          <Tab eventKey={1} title="ปฎิทินส่งมอบรถ">
            <CalendarCarAppointment ref="calendar_car_appointment" />
          </Tab>
          <Tab eventKey={4} title="ปฎิทินนัดซ่อมล่วงหน้า">
            <CalendarCarAdvanceBooking ref="calendar_car_advancebooking" />
          </Tab>
          <Tab eventKey={2} title="ปฏิทินแจ้งเตือนในระบบ">
            <CalendarNotificationInSystem ref="calendar_notification_insystem" />
          </Tab>
          <Tab eventKey={3} title="ปฏิทินแจ้งเตือน SMS">
            <CalendarNotificationSms ref="calendar_notification_sms" />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/view/calendar/Calendar.js